import React, { useState, useEffect } from "react";
import { Card, CardTitle, CardBody, Row, Col } from "reactstrap";
import SingleSuperUserNotification from "./SingleSuperUserNotification";
import Pacmanloader from "../Pacmanloader/Pacmanloader";
import { GetNotifications } from "../../actions/adminQueries";
import { FormattedMessage } from "react-intl";

export default function AdminNotificationsShow({ schoolData, licenseData }) {
  const [notificationData, setNotificationData] = useState([]);

  const notifications = GetNotifications();

  useEffect(() => {
    if (!notifications.isPending) {
      let tempNotifications = [...(notifications.data ?? [])];
      tempNotifications = tempNotifications.filter(
        (noti) => !noti.notice.isDeleted
      );
      tempNotifications = tempNotifications.sort(function (o1, o2) {
        return new Date(o2.notice.created) - new Date(o1.notice.created);
      });
      setNotificationData(tempNotifications);
    }
  }, [notifications.isPending, notifications.data]);

  if (notifications.isPending) {
    return <Pacmanloader />;
  }

  return (
    <Card>
      <CardBody>
        <CardTitle>
          <FormattedMessage id="Navigation_Notifications" />
        </CardTitle>
        <Row className="m-2 fw-bold">
          <Col lg="2">
            <FormattedMessage id="Title" />
          </Col>
          <Col lg="2">
            <FormattedMessage id="Date" />
          </Col>
          <Col lg="2">
            <FormattedMessage id="Programlicense" />
          </Col>
          <Col lg="2">
            <FormattedMessage id="School" />
          </Col>
          <Col lg="1">
            <FormattedMessage id="Receivers" />
          </Col>
          <Col lg="1" className="text-center">
            <FormattedMessage id="Popup" />
          </Col>
          <Col></Col>
        </Row>
        {notificationData.map((notification) => {
          return (
            <SingleSuperUserNotification
              key={notification.notice.id}
              notification={notification}
              schoolData={schoolData}
              licenseData={licenseData}
            />
          );
        })}
      </CardBody>
    </Card>
  );
}
